var WP_Products = {
	init:function(){
		$(window).resize(function(){
			WP_Products.resize();	
		});
		WP_Products.resize();
	},
	resize:function(){
		var _slides_to_show = 1;
		var els = document.querySelectorAll(".wc-block-grid__products");

		Array.prototype.forEach.call(els, function(el) {
			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));			
		});

		$(".wc-block-grid__products").each(function(){
			if($(this).find(".wc-block-grid__product").length > _slides_to_show){
				WP_Products.create_slider($(this), _slides_to_show);
			}else{
				WP_Products.delete_slider($(this));
			}
		});
	},
	create_slider:function(pTarget, _slides_to_show){
		WP_Products.delete_slider(pTarget);

		pTarget.parent().append('<div class="arrow-container"><div class="arrow-next"><svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"><polygon points="43.7,30 34.2,24.5 34.2,29.4 16.3,29.4 16.3,31.1 34.2,31.1 34.2,35.5 "/></svg></div></div>');

		pTarget.slick({
			arrows:true, 
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: _slides_to_show,
			focusOnSelect: true,
			touchThreshold:500,
			nextArrow:pTarget.parent().find(".arrow-next")
		});

	},
	delete_slider:function(pTarget){
		if (pTarget.hasClass('slick-initialized')) {
			pTarget.slick('unslick');
			pTarget.parent().find(".arrow-container").remove();
		}
	}
}
var WP_Gallery = {
	init:function(){
		$(".wp-block-gallery").each(function(){
			
			$(this).append('<div class="arrow-container"><div class="arrow-next"><svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"><polygon points="43.7,30 34.2,24.5 34.2,29.4 16.3,29.4 16.3,31.1 34.2,31.1 34.2,35.5 "/></svg></div></div>');
			
			var _carousel = $(this).find(".blocks-gallery-grid");
			_carousel.slick({				
				arrows:true, 
				dots:false,
				infinite: false,
				variableWidth:true,
				slidesToShow: 1,
				focusOnSelect: true,
				touchThreshold:500,
				nextArrow:_carousel.parent().find(".arrow-next")
			});
		});
	}
}
$(window).load(function(){
	if($(".wp-block-columns").length){
		$(".wp-block-columns").each(function(){
			if($(this).find(".wp-block-image").length){
				$(this).addClass("image");
			}
		})
	}
	if($(".wp-block-gallery").length){		
		WP_Gallery.init();
	}

	if($(".wp-block-handpicked-products").length){

		WP_Products.init();

		$(".wp-block-handpicked-products").each(function(){

			if($(this).find(".wc-block-grid__product").length == 2){
				$(this).addClass("two-cols");	
			}else if ($(this).find(".wc-block-grid__product").length == 3){
				$(this).addClass("three-cols");				
			}else if ($(this).find(".wc-block-grid__product").length > 3){
				$(this).addClass("slider");
			}
		})
	}
})